import { ReactNode } from 'react';

import styles from './modal-components.module.css';

type ModalBodyProps = {
  children: ReactNode;
};

export const ModalBody = ({ children }: ModalBodyProps) => <div className={styles.body}>{children}</div>;
